<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reLoad: this.reLoad
    }
  },
  data () {
    return {
      goPage: true
    }
  },
  methods: {
    reLoad() {
      this.goPage = false;
      this.$nextTick(function() {
         this.goPage = true
      })
    }
  }
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
} */
body {
  margin: 0;
  height: 100%;
  background: #f7f7f7;
}
/*********** 布局-弹性布局 ***********/

.flex {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
}

.flex-column {
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
}

.flex1 {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
}

.flex-wrap {
    flex-wrap: wrap;
}

.justify-between {
    justify-content: space-between;
}

.justify-around {
    justify-content: space-around;
}

.justify-evenly {
    justify-content: space-evenly;
}

.justify-center {
    justify-content: center;
}

.justify-end {
    justify-content: flex-end;
}

.align-start {
    align-items: flex-start;
}

.align-end {
    align-items: flex-end;
}

.align-center {
    align-items: center;
}


/*********** 布局-定位 ***********/

.positionr {
    position: relative;
}

.positiona {
    position: absolute;
}

.positionf {
    position: fixed;
}
.text333{
  color: #333;
}
.textgreen{
color: #67c23a;
}
.textred{
  color: #f56c6c;
}
.text999{
  color: #999;
}
.textblue{
  color: #409eff;
}
.textyellow{
  color: #e6a23c;
}
</style>



// WEBPACK FOOTER //
// src/App.vue